import { render, staticRenderFns } from "./serviceClassification.vue?vue&type=template&id=4c6e24dc&scoped=true&"
import script from "./serviceClassification.vue?vue&type=script&lang=js&"
export * from "./serviceClassification.vue?vue&type=script&lang=js&"
import style0 from "./serviceClassification.vue?vue&type=style&index=0&id=4c6e24dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6e24dc",
  null
  
)

export default component.exports